<template>
  <div id="orderlist" style="width: 100%;height: 100%">
    <el-row>
      <el-form :inline="true" :model="searchForm" ref="searchForm" class="demo-form-inline" style="padding-top:0;margin-top:0">
        <el-form-item label="客户：">
          <el-select size="medium" filterable v-model="searchForm.TC_ID" placeholder="请选择" clearable @change="onTCChange">
            <el-option v-for="item in companys" :key="item.ID" :label="item.AB_NAME" :value="item.ID"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="项目点：">
          <el-select size="medium" filterable v-model="searchForm.PROJECT" collapse-tags @change="__querydkList" placeholder="请选择" clearable
            @clear="clearableProject" multiple @remove-tag="removeTag">
            <el-option label="全选" value="全选"></el-option>
            <el-option v-for="item in points" :key="item.value" :label="item.PROJECT_NAME" :value="item.PROJECT_ID">
              <span style="float: left">{{ item.PROJECT_NAME }}</span>
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="档口：">
          <el-select size="medium" filterable v-model="searchForm.dkName" collapse-tags multiple placeholder="请选择档口" style="width: 100%" clearable
            @clear="clearableDkName" :filter-method="filterMethod" @change="allDkList">
            <el-checkbox v-model="searchForm.isSelectAllDkName" class="selectbox" style="padding-left:18px"
              @change="selectAllOptionsDk">全选</el-checkbox>
            <el-option v-for="item in filterDkList" :key="item.ID" :label="item.NAME" :value="item.ID">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="订单ID：">
          <el-input size="medium" v-model="searchForm.ORDER_ID" clearable></el-input>
        </el-form-item>
        <el-form-item label="日期范围：">
          <el-date-picker size="medium" v-model="searchForm.DAY_INTERVAL" type="daterange" align="right" unlink-panels range-separator="至"
            start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="送货日期：">
          <el-date-picker size="medium" v-model="searchForm.SEND_DAY" type="date" value-format="yyyy-MM-dd" placeholder="选择日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="状态：">
          <el-select size="medium" filterable v-model="searchForm.STATUS" placeholder="请选择" clearable>
            <el-option v-for="item in statusList" :key="item.value" :label="item.label" :value="item.value">
              <span style="float: left">{{ item.label }}</span>
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="转换订单类型：" v-if="activeName == '2'">
          <el-select size="medium" v-model="searchForm.CHANGE_ORDER_TYPE" placeholder="请选择">
            <el-option label="所有订单" :value="-1"></el-option>
            <el-option label="普通订单" :value="0"></el-option>
            <el-option label="第三方订单" :value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button size="medium" type="primary" id="search" @click="handleSearch" :loading="initLoad">筛选</el-button>
        </el-form-item>
      </el-form>
    </el-row>
    <el-row>
      <el-col>
        <div class="button-group">
          <el-button size="medium" @click="transferAllOrder">
            {{ ['', '转换第三方采购', '二次转换'][Number(activeName)] }}
          </el-button>
          <el-button size="medium" type="primary" plain @click="() => { activeName == '1' ? exportNotConvertedOrder() : exportConvertedOrder() }">
            导出订单
          </el-button>
          <el-button size="medium" type="primary" plain @click="openExportPDF" v-show="fun_dic[100050001]" v-if="activeName == '2'">
            导出PDF
          </el-button>
          <el-badge :value="this.markCount" class="item">
            <el-button size="medium" type="primary" plain @click="changeProducts">转换后销售单变更产品</el-button>
          </el-badge>
          <el-button size="medium" type="primary" plain v-show="fun_dic[100050002]" v-if="activeName == '2'" @click="已转换订单打印()">
            打印预览
          </el-button>
        </div>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24" style="margin-top:20px">
        <el-tabs type="border-card" @tab-click="changeContent" v-model="activeName">
          <el-tab-pane label="未转换" name="1">
            <el-table :data="newOrderListData" @selection-change="handleSelectionChange" border stripe :summary-method="getSummaries" show-summary
              style="width: 100%">
              <el-table-column type="selection" width="40"></el-table-column>
              <el-table-column label="订单ID" width="80" prop="ID"></el-table-column>
              <el-table-column prop="ORDER_CODE" label="订单编号" min-width="270"></el-table-column>
              <el-table-column prop="SEND_DAY" label="送货日期" min-width="95"></el-table-column>
              <el-table-column prop="TC_NAME" label="公司" min-width="90"></el-table-column>
              <el-table-column prop="PROJECT_NAME" label="项目点" min-width="150"></el-table-column>
              <el-table-column prop="DK_NAME" label="档口" min-width="100"></el-table-column>
              <el-table-column prop="TOTAL_SUPPLIER_FEE" label="总价（元）" min-width="100"></el-table-column>
              <el-table-column prop="COUNT" label="单品数量" min-width="100"></el-table-column>
              <el-table-column prop="SUPPLEMENT" label="是否补单" min-width="90"></el-table-column>
              <el-table-column prop="PRINT_TIME" label="打印次数" min-width="90"></el-table-column>
              <el-table-column prop="CATALOG_NAME" label="分类" min-width="100"></el-table-column>
              <el-table-column label="状态" fixed="right" min-width="100">
                <template slot-scope="scope">
                  <el-tag>{{ showOrderStatus(scope.row.STATUS) }}</el-tag>
                </template>
              </el-table-column>
              <el-table-column fixed="right" label="操作" width="70">
                <template slot-scope="scope">
                  <el-button type="text" size="small" @click="detail(scope.row, 0)">查看</el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-tab-pane>
          <el-tab-pane label="已转换" name="2">
            <el-table :data="newOrderListData" @selection-change="handleSelectionChange" border stripe :summary-method="getSummaries" show-summary
              style="width: 100%">
              <el-table-column type="selection" width="40"></el-table-column>
              <el-table-column label="订单ID" width="80" prop="ID"></el-table-column>
              <el-table-column prop="ORDER_CODE" label="订单编号" min-width="270"></el-table-column>
              <el-table-column prop="SEND_DAY" label="送货日期" min-width="135"></el-table-column>
              <el-table-column prop="TC_NAME" label="公司" min-width="90"></el-table-column>
              <el-table-column prop="PROJECT_NAME" label="项目点" min-width="150"></el-table-column>
              <el-table-column prop="DK_NAME" label="档口" min-width="100"></el-table-column>
              <el-table-column prop="TOTAL_SUPPLIER_FEE" label="总价（元）" min-width="100"></el-table-column>
              <el-table-column prop="COUNT" label="单品数量" min-width="100"></el-table-column>
              <el-table-column prop="SUPPLEMENT" label="是否补单" min-width="100"></el-table-column>
              <el-table-column prop="PRINT_TIME" label="打印次数" min-width="100"></el-table-column>
              <el-table-column prop="CATALOG_NAME" label="分类" min-width="100"></el-table-column>
              <el-table-column label="状态" min-width="100">
                <template slot-scope="scope">
                  <el-tag>{{ showOrderStatus(scope.row.STATUS) }}</el-tag>
                </template>
              </el-table-column>
              <el-table-column fixed="right" label="操作" width="70">
                <template slot-scope="scope">
                  <el-button type="text" size="small" @click="detail(scope.row, 1)">查看</el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-tab-pane>
        </el-tabs>
        <el-row>
          <el-col :span="24" style="text-align: right">
            <el-pagination @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-size="pageSize"
              layout="total,prev, pager, next, jumper" :total="totalCount"></el-pagination>
          </el-col>
        </el-row>
      </el-col>
    </el-row>
    <!-- 导出PDF模态框 -->
    <el-dialog title="导出PDF" center :visible.sync="pdfFormVisible" width="500px">
      <!-- <p style="color: red; font-size: 22px">
        导出完成后订单将从待送订单转至待确认订单
      </p> -->
      <el-form :model="pdfForm" ref="pdfForm">
        <el-form-item label="是否带价格：" :label-width="labelWidth">
          <el-radio-group v-model="pdfForm.priceRadio" style="width: 100%;">
            <el-col :span="12">
              <el-radio :label="1">是</el-radio>
            </el-col>
            <el-col :span="12">
              <el-radio :label="0">否</el-radio>
            </el-col>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="是否导出实发数量：" :label-width="labelWidth">
          <el-radio-group v-model="pdfForm.sendCountRadio" style="width: 100%;">
            <el-col :span="12">
              <el-radio :label="1">是</el-radio>
            </el-col>
            <el-col :span="12">
              <el-radio :label="0">否</el-radio>
            </el-col>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="是否带实收：" :label-width="labelWidth">
          <el-radio-group v-model="pdfForm.realCountRadio" style="width: 100%;">
            <el-col :span="12">
              <el-radio :label="1">是</el-radio>
            </el-col>
            <el-col :span="12">
              <el-radio :label="0">否</el-radio>
            </el-col>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="订单格式：" :label-width="labelWidth">
          <el-radio-group v-model="pdfForm.docType" style="width: 100%;">
            <el-col :span="12">
              <el-radio :label="1">全联单</el-radio>
            </el-col>
            <el-col :span="12">
              <el-radio :label="0">半联单</el-radio>
            </el-col>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="导出明细：" :label-width="labelWidth">
          <el-radio-group v-model="pdfForm.exportStatus" style="width: 100%;">
            <el-col :span="12">
              <el-radio :label="1">全部明细</el-radio>
            </el-col>
            <el-col :span="12">
              <el-radio :label="2">供应商配送明细</el-radio>
            </el-col>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="pdfFormVisible = false">取 消</el-button>
        <el-button @click="submitExportPDF">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import {
  haveDSXMDFun, selectTCFun, thirdPartyExportPDFFun, notOrderDetailFun,
} from 'api/sellOrder';

import http from '@/assets/common/http';
import { getActionFun } from '@/assets/api/login';
import util from '@/assets/common/util';
import validation from '@/assets/common/validation';

export default {
  data() {
    return {
      订单状态: [],
      PAGE_ID: '1000500', // 页面ID 一旦规定不要轻易改动
      fun_dic: { 100050001: 0, 100050002: 0 },
      initLoad: false,
      customers: [],
      points: [
      ],
      allProjectsCopy: [],
      dkList: [],
      filterDkList: [],
      newOrderListData: [],
      currentPage: 1,
      totalCount: 0,
      pageSize: 10,
      index: 0,
      markCount: 0,
      searchForm: JSON.parse(sessionStorage.getItem('supplierSendOrderTBSsearchForm')) ? JSON.parse(sessionStorage.getItem('supplierSendOrderTBSsearchForm')) : {
        SUPPLIER: '', DAY_INTERVAL: [], TC_ID: '', PROJECT: [], dkName: [], SEND_DAY: '', STATUS: '', CHANGE_ORDER_TYPE: -1, isSelectAllDkName: false,
      },
      statusList: [
        {
          value: '0',
          label: '未转',
        },
        {
          value: '1',
          label: '已转',
        },
      ],
      XF_FLAG: sessionStorage.getItem('XF_FLAG'),
      companys: [],
      checkedArray: [],
      已转换订单打印勾选列表: [],
      pdfFormVisible: false,
      pdfForm: {
        priceRadio: 1,
        sendCountRadio: 1,
        realCountRadio: 0,
        docType: 1,
        exportStatus: 2,
      },
      USE_PRINT_TEMPLATE: 0, // 打印模板
      labelWidth: '150px',
      activeName: '1',
      flag: 0,
    };
  },
  created() {
    this.queryChangeProductData(); // 查询角标数量
    this.queryBeforeFun();
    // 这里用来在设置中设置页面展示条目，文件在setting的generalSettings中，由前端控制条目，存储于localStorage中，key为SMP_PAGE_COUNT
    this.pageSize = Number(localStorage.getItem('SMP_PAGE_COUNT')) ? Number(localStorage.getItem('SMP_PAGE_COUNT')) : 10;
    this.queryCustomer();
    // 获取项目点列表
    if (this.SUPPLIER_SEND_ORDER_CONDITION.CONDITION) {
      this.searchForm = this.SUPPLIER_SEND_ORDER_CONDITION.CONDITION;
      this.currentPage = this.SUPPLIER_SEND_ORDER_CONDITION.CURRENT_PAGE;
      this.activeName = this.SUPPLIER_SEND_ORDER_CONDITION.TABLE_FLAG;
    }
    this.queryProject();
    if (this.searchForm.PROJECT && this.searchForm.PROJECT.length !== 0) {
      this.__querydkList();
    }
    // 获取团餐客户订单列表
    this.queryNewOrderListData();
  },
  computed: {
    // 上一次的搜索结果和条件
    SUPPLIER_SEND_ORDER_CONDITION() {
      return this.$store.state.SUPPLIER_SEND_ORDER_CONDITION;
    },
  },
  watch: {
    searchForm: {
      handler(n, o) {
        this.searchForm.isSelectAllDkName = this.dkList.length && (n.dkName.length === this.dkList.length);
      },
      deep: true,
    },
    dkList: {
      handler(n, o) {
        this.filterDkList = n;
        this.searchForm.isSelectAllDkName = this.dkList.length && (this.searchForm.dkName.length === this.dkList.length);
      },
      deep: true,
    },
  },
  methods: {
    // 是否使用模板
    async queryForm(e) {
      const params = {
        SERVICE_ID: '12013',
        OTYPE: 7,
        USER_ID: sessionStorage.getItem('userId'),
        SESSION: sessionStorage.getItem('session'),
        SUPPLIER_ID: sessionStorage.getItem('tcId'),
        IS_SUPPLIER_CLIENT: 0,
        TC_ID: e,
      };
      try {
        const result = await http.post(params);
        this.USE_PRINT_TEMPLATE = result[0].USE_PRINT_TEMPLATE;
      } catch (error) {
        this.$message.show({ text: error, type: 'error' });
      }
    },
    // 控制功能按钮
    queryBeforeFun() {
      const params = {
        PAGE_ID: this.PAGE_ID,
      };
      getActionFun(params).then((result) => {
        if (result.length !== 0) {
          this.forMenu(result, this.fun_dic);
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    forMenu(e) {
      const tmp_fun_list = e;
      for (let i = 0; i < tmp_fun_list.length; i++) {
        for (const key in this.fun_dic) {
          if (tmp_fun_list[i].FUNCTION_NUM == key) {
            this.fun_dic[key] = 1;
          }
        }
      }
    },
    // -------------------------------------选择客户
    queryCustomer() {
      selectTCFun().then((result) => {
        if (result.length !== 0) {
          // this.companys = result[0].company;
          this.companys = [...new Set(result[0].company.map((item) => JSON.stringify(item)))].map((item) => JSON.parse(item));
        } else {
          this.companys = [];
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    detail(row, isConverted) {
      sessionStorage.setItem('sendDay', row.SEND_DAY);
      sessionStorage.setItem('orderId', row.ID);
      sessionStorage.setItem('projectid', row.PROJECT_ID);
      sessionStorage.setItem('CAN_MODIFY_PRICE', row.CAN_MODIFY_PRICE);
      sessionStorage.setItem('ORDER_TC_ID', row.TC_ID);
      sessionStorage.setItem('supplierSendOrderTBSsearchForm', JSON.stringify(this.searchForm));
      sessionStorage.setItem('isConverted', isConverted);
      sessionStorage.setItem('TC_STATUS', row.TC_STATUS);
      this.$router.push({ path: '/supplierSendOrderDetail/detail' });
    },
    changeContent(e) {
      this.queryNewOrderListData();
    },
    // 查询角标总数
    queryChangeProductData() {
      const params = {
        SERVICE_ID: '10179',
        OTYPE: 110,
        SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
        PAGESIZE: 1,
        PAGEINDEX: this.currentPage - 1,
      };
      http.post(params).then((result) => {
        if (result.length > 0) {
          this.markCount = result[0].TOTAL_COUNT;
        } else {
          this.markCount = 0;
        }
      });
    },
    // 去除多选
    removeTag(e) {
      if (e === '全选') {
        this.searchForm.PROJECT = [];
      }
    },
    // -----------------------获取新订单列表
    queryNewOrderListData() {
      if (this.searchForm.ORDER_ID && !validation.订单ID验证(this.searchForm.ORDER_ID)) {
        this.$message.show({ text: '订单ID只能输入数字', type: 'warning' });
        return false;
      }
      const params = {
        SERVICE_ID: '10179',
        OTYPE: 1,
        SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
        PAGESIZE: this.pageSize,
        PAGEINDEX: this.currentPage - 1,
        ORDER_TYPE: Number(this.activeName),
      };
      if (this.searchForm.TC_ID) {
        params.TC_ID = this.searchForm.TC_ID;
      }
      if (this.searchForm.PROJECT && this.searchForm.PROJECT.length !== 0) {
        params.PROJECTS_ID = JSON.parse(JSON.stringify(this.searchForm.PROJECT));
      }
      if (this.searchForm.dkName && this.searchForm.dkName.length !== 0) {
        params.DKS_ID = this.searchForm.dkName;
      }
      if (this.searchForm.SEND_DAY) {
        params.SEND_DAY = this.searchForm.SEND_DAY;
      }
      if (this.searchForm.DAY_INTERVAL && this.searchForm.DAY_INTERVAL[0]) {
        params.START_DAY = this.searchForm.DAY_INTERVAL[0];
        params.END_DAY = this.searchForm.DAY_INTERVAL[1];
      }
      if (this.searchForm.ORDER_ID) {
        params.ORDER_ID = this.searchForm.ORDER_ID;
      }
      if (this.searchForm.STATUS) {
        params.SUPPLIER_STATUS = this.searchForm.STATUS;
      }
      if (Number(this.searchForm.CHANGE_ORDER_TYPE) >= 0) {
        params.CHANGE_ORDER_TYPE = this.searchForm.CHANGE_ORDER_TYPE;
      }
      this.initLoad = true;
      http.post(params).then((result) => {
        if (result.length > 0) {
          this.newOrderListData = result[0].list;
          this.totalCount = result[0].TOTAL_COUNT;
          // 将搜索结果和条件存储到vuex中
          this.$store.dispatch('SET_SUPPLIER_SEND_ORDER_CONDITION', {
            CONDITION: this.searchForm,
            CURRENT_PAGE: this.currentPage,
            TABLE_FLAG: this.activeName,
          });
        } else {
          this.newOrderListData = [];
          this.totalCount = 0;
        }
        this.initLoad = false;
      }).catch((error) => {
        this.initLoad = false;
        this.$message.show({ text: error, type: 'error' });
      });
    },
    handleCurrentChange(e) {
      this.currentPage = e;
      this.queryNewOrderListData();
    },
    // ----------------------------------------点击筛选按钮触发
    handleSearch() {
      this.currentPage = 1;
      // 获取团餐客户订单列表
      this.queryNewOrderListData();
    },
    // ---------------------------------------获取项目点信息列表
    queryProject() {
      const params = {};
      if (this.searchForm.TC_ID) params.TC_ID = this.searchForm.TC_ID;
      haveDSXMDFun(params).then((result) => {
        this.points = result.length > 0 ? result[0].project : [];
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    // 清除项目点
    clearableProject() {
      this.searchForm.dkName = '';
    },
    clearableDkName() {
      this.searchForm.isSelectAllDkName = false;
    },
    filterMethod(value) {
      this.filterDkList = this.dkList.filter((item) => item.NAME.includes(value));
    },
    selectAllOptionsDk() {
      if (this.searchForm.isSelectAllDkName) {
        this.searchForm.dkName = this.filterDkList.map((item) => item.ID);
      } else {
        this.searchForm.dkName = [];
      }
      this.searchForm.isSelectAllDkName = this.searchForm.dkName.length === this.dkList.length;
    },
    // 全选档口
    allDkList(e) {
      if (e) {
        if (e.length === this.dkList.length) {
          this.searchForm.isSelectAllDkName = true;
        } else {
          this.searchForm.isSelectAllDkName = false;
        }
      }
    },
    // ----------------------------------------------下拉框获取档口名称
    __querydkList(e) {
      // el-select 选中值发生变化时触发，e为目前选中的值
      if (e) {
        const end = e[e.length - 1];
        if (!e.includes('全选') && e.length === this.points.length) {
          e.unshift('全选');
        } else if (e.includes('全选') && e.length == 1) {
          this.points.map((item) => {
            e.push(item.PROJECT_ID);
          });
        } else if (e.includes('全选') && e.length - 1 < this.points.length && end == '全选') {
          e = [];
          this.points.map((item) => {
            e.push(item.PROJECT_ID);
          });
          e.unshift('全选');
        } else if (e.includes('全选') && e.length - 1 < this.points.length) {
          e = e.filter((item) => item !== '全选');
        }
        this.searchForm.PROJECT = e;
      }
      this.queryDkList();
    },
    queryDkList() {
      if (this.searchForm.PROJECT.length === 0) {
        // 当项目点选框为空时，不获取档口名称
        this.dkList = [];
        // this.filterDkList = [];
        return false;
      }
      const params = {
        SERVICE_ID: '10007',
        OTYPE: 4,
        SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
      };
      if (this.searchForm.PROJECT) {
        params.PROJECTS_ID = this.searchForm.PROJECT.filter((x) => x != '全选');
      } else {
        this.dkList = [];
        return false;
      }
      http.post(params).then((result) => {
        this.dkList = util.listRemoveDuplicates(result);
      }).catch((err) => {
        this.$message.show({ text: err, type: 'error' });
      });
    },
    handleSelectionChange(val) {
      this.checkedArray = val.map((item) => ({ ORDER_ID: item.ID }));
      this.已转换订单打印勾选列表 = val;
    },
    async 已转换订单打印() {
      if (this.已转换订单打印勾选列表.length == 0) {
        this.$message.show({ text: '请选勾选订单', type: 'warning' });
        return;
      }
      const e = this.已转换订单打印勾选列表[0].TC_ID;
      await this.queryForm(e);

      if (this.USE_PRINT_TEMPLATE == 0) {
        this.$message.show({ text: '未使用打印模板,不可操作', type: 'warning' });
        return;
      }
      const Set的送货日期 = new Set();
      const Set的档口 = new Set();
      for (const item of this.已转换订单打印勾选列表) {
        Set的送货日期.add(item.SEND_DAY);
        Set的档口.add(item.DK_ID);
      }
      if (Set的送货日期.size > 1) {
        this.$message.show({ text: '所勾选的送货日期不同,不可打印', type: 'warning' });
        return;
      }
      if (Set的档口.size > 1) {
        this.$message.show({ text: '所勾选的档口不同,不可打印', type: 'warning' });
        return;
      }// this.checkedArray
      let 订单状态 = '';
      const 所要打印的订单列表 = this.已转换订单打印勾选列表.map(({ ID }) => ID);


      const params = {
        ID: 所要打印的订单列表[0],
        FILTER_FLAG: 0,
        GYS_ID: sessionStorage.getItem('tcId'),
        Supplier_Third_Type: 1,
      };
      notOrderDetailFun(params).then((result) => {
        订单状态 = result[0].TITLE[0].STATUS;
        if ([6, 7, 8, 9].includes(订单状态)) {
          this.$router.push({ name: 'toBeConfirmePrintDetail', params: { isThirdParty: 1 } });
          sessionStorage.setItem('isSummaryPrinting', 1);
          sessionStorage.setItem('所要打印的订单列表', JSON.stringify(所要打印的订单列表));
          sessionStorage.setItem('TEM_TCID', result[0].ASSOCIATED_PERSON[0].TC_ID);
        } else {
          this.$router.push({ name: 'sellOrderCustomPrintDetail', params: { isThirdParty: 1 } });
          sessionStorage.setItem('所要打印的订单列表', JSON.stringify(所要打印的订单列表));
          sessionStorage.setItem('isSummaryPrinting', 1);
          sessionStorage.setItem('TEM_TCID', result[0].ASSOCIATED_PERSON[0].TC_ID);
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    transferAllOrder() {
      if (this.checkedArray.length == 0) {
        if (this.searchForm.DAY_INTERVAL == null || this.searchForm.DAY_INTERVAL.length < 2) {
          this.$message.show({ text: '请选择订单或日期范围', type: 'warning' });
          return;
        }
      }
      const params = {
        CHANGES_NUM: this.activeName - 1,
        SERVICE_ID: '10179',
        OTYPE: 30,
        GYS_ID: Number(sessionStorage.getItem('tcId')),
        PRICE_MODE: sessionStorage.getItem('PRICE_MODE'),
      };
      if (this.checkedArray.length !== 0) {
        this.tmpOrderId = [];
        this.checkedArray.forEach((item, index) => {
          this.tmpOrderId.push(item.ORDER_ID);
        });
        this.submitArr = this.tmpOrderId.filter((ele, index, self) => self.indexOf(ele) === index);
        params.ORDER_IDS = this.submitArr;
      }
      if (this.searchForm.DAY_INTERVAL && this.searchForm.DAY_INTERVAL[0]) {
        params.START_DAY = this.searchForm.DAY_INTERVAL[0];
        params.END_DAY = this.searchForm.DAY_INTERVAL[1];
      }
      http.post(params).then((result) => {
        if (!result.length) {
          this.$message.show({ text: '操作成功', type: 'success' });
        } else {
          if (JSON.stringify(result[0]) != '{}') {
            this.有问题的订单集合 = result[0];
            sessionStorage.setItem('有问题的订单集合', JSON.stringify(this.有问题的订单集合));
            this.$router.push({ path: '/thirdPartyTransferErrorProductList_test' });
          } else {
            this.$message.show({ text: '部分订单转换失败,请检查订单', type: 'error' });
          }
        }
        this.queryNewOrderListData();
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    exportNotConvertedOrder() {
      const params = {
        SERVICE_ID: '10179',
        OTYPE: 4,
        SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
        XF_FLAG: 0,
      };
      // 若已勾选，则以勾选为主，若未勾选，则判断是否有选中日期范围和送货日期
      if (this.checkedArray.length !== 0) {
        this.tmpOrderId = [];
        this.checkedArray.forEach((item, index) => {
          this.tmpOrderId.push(item.ORDER_ID);
        });
        this.submitArr = this.tmpOrderId.filter((ele, index, self) => self.indexOf(ele) === index);
        params.ORDER_IDS = this.submitArr;
      } else if (this.searchForm.SEND_DAY) {
        params.SEND_DAY = this.searchForm.SEND_DAY;
      } else if (this.searchForm.DAY_INTERVAL && this.searchForm.DAY_INTERVAL.length) {
        params.START_DAY = this.searchForm.DAY_INTERVAL[0];
        params.END_DAY = this.searchForm.DAY_INTERVAL[1];
      } else {
        this.$message.show({ text: '订单勾选、送货日期、日期范围至少选择一个', type: 'warning' });
        return false;
      }

      http.post(params).then((result) => {
        if (result[0] && result[0].TASK_CREATED_SUCCESSFULLY) {
          this.$util.getUnreadInformation(this);
          this.$confirm(this.$util.appointmentMessage, '温馨提示', {
            confirmButtonText: '确定', cancelButtonText: '取消', type: 'success', dangerouslyUseHTMLString: true,
          }).then(() => {
            this.$router.push({ name: 'appointmentHandling' });
          }).catch(() => {
            this.$message.show({ type: 'info', text: '取消操作' });
          });
        } else if (result[0].FILE_PATH) {
          window.location.href = this.$util.getURLLocalHost(result[0].FILE_PATH);
        } else {
          this.$message.show({ text: '暂无数据', type: 'warning' });
        }
      }).catch((error) => {
        this.initLoad = false;
        this.$message.show({ text: error, type: 'error' });
      });
    },
    exportConvertedOrder() {
      const params = {
        SERVICE_ID: '10179',
        OTYPE: 9,
        SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
        ORDER_TYPE: 1,
      };
      // 若已勾选，则以勾选为主，若未勾选，则判断是否有选中日期范围和送货日期
      if (this.checkedArray.length !== 0) {
        this.tmpOrderId = [];
        this.checkedArray.forEach((item, index) => {
          this.tmpOrderId.push(item.ORDER_ID);
        });
        this.submitArr = this.tmpOrderId.filter((ele, index, self) => self.indexOf(ele) === index);
        params.ORDER_IDS = this.submitArr;
      } else if (this.searchForm.SEND_DAY) {
        params.SEND_DAY = this.searchForm.SEND_DAY;
      } else if (this.searchForm.DAY_INTERVAL && this.searchForm.DAY_INTERVAL.length) {
        params.START_DAY = this.searchForm.DAY_INTERVAL[0];
        params.END_DAY = this.searchForm.DAY_INTERVAL[1];
      } else {
        this.$message.show({ text: '订单勾选、送货日期、日期范围至少选择一个', type: 'warning' });
        return false;
      }
      if (Number(this.searchForm.CHANGE_ORDER_TYPE) >= 0) {
        params.CHANGE_ORDER_TYPE = this.searchForm.CHANGE_ORDER_TYPE;
      }
      http.post(params).then((result) => {
        if (result[0].FILE_PATH !== '') {
          window.location.href = util.getURLLocalHost(result[0].FILE_PATH);
        } else {
          this.$message.show({ text: '暂无数据', type: 'error' });
        }
      }).catch((error) => {
        this.initLoad = false;
        this.$message.show({ text: error, type: 'error' });
      });
    },
    // 转换后变更产品
    changeProducts() {
      this.$router.push({ path: 'changeProductsAfterConversion' });
    },
    openExportPDF() {
      if (this.checkedArray.length === 0 && !this.searchForm.SEND_DAY) {
        this.$message.show({ text: '请选择送货日期或对订单进行勾选', type: 'warning' });
      } else if (this.checkedArray.length !== 0 || this.searchForm.SEND_DAY) {
        this.pdfFormVisible = true;
      }
    },
    submitExportPDF() {
      const params = {
        SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
        PRICE_FLAG: this.pdfForm.priceRadio,
        SEND_COUNT_FLAG: this.pdfForm.sendCountRadio,
        iRCOUNTFlag: this.pdfForm.realCountRadio,
        HALF_PAGE_FLAG: this.pdfForm.docType,
        EXPORT_STATUS: this.pdfForm.exportStatus,
      };
      if (this.checkedArray.length) {
        params.ORDER_LIST = this.checkedArray.map((item) => item.ORDER_ID);
      }
      if (this.searchForm.SEND_DAY) {
        params.SEND_DAY = this.searchForm.SEND_DAY;
      }
      thirdPartyExportPDFFun(params).then((result) => {
        if (result[0]) {
          this.$message.show({ text: '导出PDF成功', type: 'success' });
          this.pdfFormVisible = false;
          window.location.href = this.$util.getURLLocalHost(result[0].FILE_PATH);
        } else {
          this.$message.show({ text: '暂无数据', type: 'warning' });
          this.pdfFormVisible = false;
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    // 单元格合计
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计';
          return;
        }
        const values = data.map((item) => Number(item[column.property]));
        if (column.property === 'COUNT' || column.property === 'TOTAL_SUPPLIER_FEE') {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return Math.floor((prev + value) * 100) / 100;
            }
            return prev;
          }, 0);
        }
      });
      this.sums = sums;
      return sums;
    },
    showOrderStatus: util.showOrderStatus,
    onTCChange() {
      this.searchForm.PROJECT = [];
      this.queryProject();
    },
  },
};
</script>
<style scoped>
.item {
  margin-top: 5px;
  margin-right: 30px;
  line-height: 100%;
}

.item >>> .el-badge__content {
  right: 20px;
}

.button-group {
  display: flex;
  align-items: center;
}

.custom-button,
.item {
  margin: 0 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/sellOrderManage/supplierSendOrder.vue